import React from "react";
import { Link } from "react-router-dom";
import { Bot, Search, Sparkles, Send, Calendar, Shield } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

export default function ReplyAgent() {
  return (
    <MarketingPage
      seo={{
        title: "Reply Agent — AI replies for X, LinkedIn & Reddit",
        description:
          "Collavue's Reply Agent drafts on-brand replies to people asking for what you offer on X (Twitter), LinkedIn, and Reddit. Human-in-the-loop approval, intent scoring, and pipeline attribution built in.",
        path: "/reply-agent",
        keywords:
          "AI reply agent, automated X replies, automated Twitter replies, automated LinkedIn replies, LinkedIn outreach AI, AI social outreach, X DM AI, Twitter reply automation",
      }}
    >
      <PageHero
        eyebrow="Collavue · Reply Agent"
        title="The AI Reply Agent that books demos"
        italicWord="while you sleep."
        description="Reply Agent watches X (Twitter), LinkedIn, and Reddit, drafts replies in your brand voice, and queues them for one-click human approval."
      >
        <div className="flex flex-wrap gap-3">
          <Link to="/signup" className="px-6 py-3 rounded-md bg-[#0a1736] text-white font-medium hover:bg-[#1c2a4d]">
            Try Reply Agent
          </Link>
          <Link to="/case-studies" className="px-6 py-3 rounded-md bg-white text-[#0a1736] border border-[#e3dccb] font-medium hover:border-[#0a1736]">
            See it in action
          </Link>
        </div>
      </PageHero>

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: Search, title: "Find", body: "Continuous X (Twitter), LinkedIn & Reddit coverage." },
            { icon: Sparkles, title: "Score", body: "Intent + ICP-fit scoring 0–100." },
            { icon: Bot, title: "Reply", body: "Drafts in your brand voice." },
            { icon: Send, title: "Approve", body: "Human-in-the-loop send." },
          ].map((s) => (
            <div key={s.title} className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
              <s.icon className="w-6 h-6 text-[#2d5bff]" />
              <h3 className="font-display text-xl text-[#0a1736] font-semibold mt-3">{s.title}</h3>
              <p className="text-[#5a6478] text-sm mt-2 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#0a1736] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-6">
          <Stat icon={Calendar} number="38" label="Demos / month booked from public complaints" />
          <Stat icon={Bot} number="11s" label="Average human approval time on a draft" />
          <Stat icon={Shield} number="0" label="Auto-posts without your approval" />
        </div>
      </section>
    </MarketingPage>
  );
}

function Stat({ icon: Icon, number, label }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-6">
      <Icon className="w-6 h-6 text-[#bef264]" />
      <div className="font-display text-4xl mt-3">{number}</div>
      <div className="text-white/70 text-sm mt-1">{label}</div>
    </div>
  );
}
